import React from 'react';
import { Navigate } from "react-router-dom";
import AuthService from "../services/auth.service";

function ACL({ children, roles }) {  
  const user = AuthService.getCurrentUser();
  return (!user || !user.role) ? <Navigate to="/login" replace /> : (user.role && roles.includes(user.role)) ? children : <Navigate to="/unauthorized" replace />
}

export default ACL